import { render, staticRenderFns } from "./ProductConcernSubstancesStep.vue?vue&type=template&id=6390b7dd&"
import script from "./ProductConcernSubstancesStep.vue?vue&type=script&lang=js&"
export * from "./ProductConcernSubstancesStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports